<template>
  <div class="app-page home">
    <vue-headful title="ALICE | Dashboard"></vue-headful>
    <div class="home-wrapper">
      <!-- header -->
      <div class=" page-header">
            <p class="head-title">Dashboard</p>
        <div class="filter-wrapper">
          <!-- channel dropdown -->
          <div class="channel-dropdown-content">
            <div class="channel-selected" @click="onClickChannelContent">
              <p>{{ channelFilter.toUpperCase() }}</p>
              <i class="bx bx-caret-up" v-if="isOpenChannelDropdown"></i>
              <i class="bx bx-caret-down" v-else></i>
            </div>
            <div class="channel-dropdown" v-if="isOpenChannelDropdown">
              <div
              v-for="ch in channelListData" :value="ch" :key="ch"
              @click="toggleChannelFilter(ch)"
              class="channel-item" :class="{'selected-channel': channelFilter.toLowerCase() === ch.toLowerCase()}">
              {{ ch.toUpperCase() }}
            </div>
            </div>
          </div>

          <div class="date-picker-content">
            <date-range-picker
            v-model="dateRange"
            :show-dropdowns="true"
            :maxDate="maxDate"
            :date-format="dateFormat"
            :ranges = "dateRangesSelector"
            opens="left"
            @start-selection="setStartDateSelection"
            @finish-selection="setEndDateSelection"
            @toggle="onCalendarToggle"
            >
              <div class="date-picker-input" slot="input" >
                <i class="bx bx-calendar"></i>{{ formatDate(this.dateRange.startDate) }} - {{ formatDate(this.dateRange.endDate) }}
              </div>
            </date-range-picker>
          </div>
<!--              <button class="export-button">-->
<!--                <i class='bx bx-export'></i>-->
<!--                Export-->
<!--              </button>-->
        </div>
      </div>
      <!-- header -->

      <!-- Tab Navigation -->
      <div class="dashboard-tab-navigation">
        <div class="tab-item" :class="{'selected-tab':selectedTab === 'botUsageAndPerformance'}" @click="onClickTabNavigation('botUsageAndPerformance')">
          <p>Bot Usage & Performance</p>
        </div>
        <div v-if="!menuConfig.generativeAIUsage.isHide" class="tab-item " :class="{'selected-tab':selectedTab === 'genAIUsage'}" @click="onClickTabNavigation('genAIUsage')">
          <p>Gen AI Usage</p>
        </div>
        <div v-if="!menuConfig.satisfaction.isHide" class="tab-item " :class="{'selected-tab':selectedTab === 'customerSatisfaction'}" @click="onClickTabNavigation('customerSatisfaction')">
          <p>Customer Satisfaction</p>
        </div>
      </div>
      <!-- Tab Navigation -->
       <!-- content -->
      <div v-if="isValidDateRange">
          <!-- Bot Usage and Performance -->
        <div class="home-content" v-if="selectedTab ==='botUsageAndPerformance'">
          <!-- User Engagement Section -->
        <div class="dashboard-row">
          <p class="section-title">User Engagement</p>
        <div class="dashboard-card-wrapper">
            <div class="dashboard-card no-sub-detail">
              <!-- Total user -->
              <div class="card-headline with-icon">
                <p>Total User</p>
              <img src="@/assets/dashboard-icon/total-user.png" alt="total user icon">
              </div>
              <div>
                <div class="card-detail">
                  <div class="card-main-detail">
                    <p>{{ userEngagemnetStat.totalUser| number }} </p>
                    <div>
                      <span v-if="isTrendValueInvalid(userEngagemnetStat.totalUserTrend)"></span>
                      <span v-else-if="userEngagemnetStat.totalUserTrend === 0" class="no-chagnge-text">No Change</span>
                      <span v-else class="stat-badge" :class="{'increase': userEngagemnetStat.totalUserTrend > 0, 'decrease': userEngagemnetStat.totalUserTrend < 0}">
                        <i class="fas fa-arrow-up"></i> {{ userEngagemnetStat.totalUserTrend| number }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <!-- New user -->
            <div class="dashboard-card">
              <div class="card-headline with-icon">
                <p>New User</p>
                <img src="@/assets/dashboard-icon/new-user.png" alt="new user icon">
              </div>
              <div>
                <div class="card-detail">
                  <div class="card-main-detail">
                    <p>{{ userEngagemnetStat.newUser| number }}</p>
                    <div>
                      <span v-if="isTrendValueInvalid(userEngagemnetStat.newUserTrend)"></span>
                      <span v-else-if="userEngagemnetStat.newUserTrend === 0" class="no-chagnge-text">No Change</span>
                      <span v-else class="stat-badge" :class="{'increase': userEngagemnetStat.newUserTrend > 0, 'decrease': userEngagemnetStat.newUserTrend < 0}">
                        <i class="fas fa-arrow-up"></i> {{ userEngagemnetStat.newUserTrend| number }}%
                      </span>
                    </div>
                  </div>
                <p class="card-sub-detail"> {{ userEngagemnetStat.newUserCompareToActive }}% of total users</p>
                </div>
              </div>
            </div>
            <!-- Return user -->
            <div class="dashboard-card">
              <div class="card-headline with-icon">
                <p>Return User</p>
                <img src="@/assets/dashboard-icon/return-user.png" alt="return user icon">
              </div>
              <div>
                <div class="card-detail">
                  <div class="card-main-detail">
                    <p>{{ userEngagemnetStat.returnUser| number }}</p>
                    <div>
                      <span v-if="isTrendValueInvalid(userEngagemnetStat.returnUserTrend)"></span>
                      <span v-else-if="userEngagemnetStat.returnUserTrend === 0" class="no-chagnge-text">No Change</span>
                      <span v-else class="stat-badge " :class="{'increase': userEngagemnetStat.returnUserTrend > 0, 'decrease': userEngagemnetStat.returnUserTrend < 0}">
                        <i class="fas fa-arrow-up"></i> {{ userEngagemnetStat.returnUserTrend| number }}%
                      </span>
                    </div>
                  </div>
                <p class="card-sub-detail"> {{ userEngagemnetStat.returnUserCompareToActive }}% of total users</p>
                </div>
              </div>
            </div>
            <!--Average DAU  -->
            <div class="dashboard-card no-sub-detail">
              <div class="card-headline with-icon">
                <p>Average DAU</p>
                <img src="@/assets/dashboard-icon/average-dau.png" alt="average dau icon">
              </div>
              <div>
                <div class="card-detail">
                  <div class="card-main-detail">
                    <p> {{ userEngagemnetStat.averageDailyActiveUser | number }} <span class="text-unit">users</span></p>
                    <div>
                      <span v-if="isTrendValueInvalid(userEngagemnetStat.totalUserTrend)"></span>
                      <span v-else-if="userEngagemnetStat.averageDailyActiveUserTrend === 0" class="no-chagnge-text">No Change</span>
                      <span v-else class="stat-badge" :class="{'increase': userEngagemnetStat.averageDailyActiveUserTrend > 0, 'decrease': userEngagemnetStat.averageDailyActiveUserTrend < 0}">
                        <i class="fas fa-arrow-up"></i> {{ userEngagemnetStat.averageDailyActiveUserTrend| number }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="active-user-content">
            <div id='loading' :class="{'d-none': loadingState}">
              <div style='position: absolute; z-index: 10;'>
                <img src='../assets/images/ui_loading.png'>
              </div>
            </div>
            <active-user-widget :criteria="currentCriteria"></active-user-widget>
          </div>
        </div>
          <!-- User Engagement Section -->

          <!--Incoming Message & Fallback Section -->
          <div class="dashboard-row">
            <p class="section-title">Transactions & Fallback Rate</p>
            <div class="dashboard-card-wrapper">
            <div class="dashboard-card dashboard-card-icon-left">
              <!-- Total Messages -->
  <!--            <img src="@/assets/dashboard-icon/message-icon.png" alt="total message icon">-->
              <div>
                <div class="card-headline with-tooltip">
                  <p>Total Transactions</p>
                  <section class="ml-1 b-tooltips">
                    <b-tooltip
                    label="จำนวนข้อความทั้งหมดที่ผู้ใช้งานส่งเข้ามาคุยกับบอท ทั้งในรูปแบบข้อความ (Message) และการกด Call To Action ต่างๆ (Event)"
                    position="is-right"
                    type="is-light"
                    multilined>
                      <div>
                        <i class='bx bx-info-circle'></i>
                      </div>
                    </b-tooltip>
                  </section>
                </div>
                <div>
                  <div class="card-detail">
                    <div class="card-main-detail">
                      <p>{{ incomingMessageStat.totalTransactions | number }} </p>
                      <div>
                      <span v-if="isTrendValueInvalid(incomingMessageStat.totalTransactionTrend)"></span>
                      <span v-else-if="incomingMessageStat.totalTransactionTrend === 0" class="no-chagnge-text">No Change</span>
                      <span v-else class="stat-badge" :class="{'increase': incomingMessageStat.totalTransactionTrend > 0, 'decrease': incomingMessageStat.totalTransactionTrend < 0}">
                      <i class="fas fa-arrow-up"></i> {{ incomingMessageStat.totalTransactionTrend| number }}%
                      </span>
                      </div>
                    </div>
                    <p class="card-sub-detail">
                      <span>
                        {{ incomingMessageStat.totalTextEventMessage | number }}
                      </span>messages</p>
                  </div>
                </div>
              </div>
            </div>
              <!-- Avg message per day  -->
            <div class="dashboard-card">
              <div class="card-headline with-tooltip">
                <p>Avg. transactions per day</p>
                <section class="ml-1 b-tooltips">
                    <b-tooltip
                    label="จำนวนข้อความเฉลี่ยต่อวันที่ผู้ใช้งานส่งเข้ามาคุยกับบอท"
                    position="is-right"
                    type="is-light"
                    multilined>
                      <div>
                        <i class='bx bx-info-circle'></i>
                      </div>
                    </b-tooltip>
                  </section>
              </div>
              <div>
                <div class="card-detail">
                  <div class="card-main-detail">
                    <p>{{ incomingMessageStat.avgMessagePerDay | number }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Avg message per user -->
            <div class="dashboard-card">
              <div class="card-headline with-tooltip">
                <p>Avg. transactions per user</p>
                <section class="ml-1 b-tooltips">
                    <b-tooltip
                    label="จำนวนข้อความเฉลี่ยต่อผู้ใช้งานที่คุยกับบอท"
                    position="is-right"
                    type="is-light"
                    multilined>
                      <div>
                        <i class='bx bx-info-circle'></i>
                      </div>
                    </b-tooltip>
                  </section>
              </div>
              <div>
                <div class="card-detail">
                  <div class="card-main-detail">
                    <p>{{ incomingMessageStat.avgMessagePerUser | number}}</p>
                  </div>
                </div>
              </div>
            </div>
            <!--Fallback Messages  -->
            <div class="dashboard-card">
              <div class="card-headline with-tooltip">
                <p>Fallback Messages</p>
                <section class="ml-1 b-tooltips">
                  <b-tooltip
                  label="จำนวนข้อความที่บอทไม่สามารถตอบได้"
                  position="is-left"
                  type="is-light"
                  multilined>
                    <div label="Right">
                      <i class='bx bx-info-circle'></i>
                    </div>
                  </b-tooltip>
                </section>
              </div>
              <div>
                <div class="card-detail">
                  <div class="card-main-detail">
                    <p>{{ botPerformanceData.fallbackMessageCount | number }}</p>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>

        <div class="dashboard-row">
          <div id='loading' :class="{'d-none': loadingState}">
              <div style='position: absolute; z-index: 10;'>
                <img src='../assets/images/ui_loading.png'>
              </div>
          </div>
          <div class="message-fallback-chart">
              <div class="message-fallback-card-widget daily-incoming-message">
                <incoming-message-widget :criteria="currentCriteria"></incoming-message-widget>
              </div>
              <!-- fallback -->
              <div class="message-fallback-card-widget fallback">
                <bot-performance-widget :criteria="currentCriteria"></bot-performance-widget>
              </div>
          </div>
        </div>
          <!--Message & Fallback Section -->

        <!-- Trending Topics -->
        <div class="dashboard-row">
          <p class="section-title">Trending Topics</p>
        </div>
        <div>
          <trending-topics-widget :criteria="currentCriteria"></trending-topics-widget>
        </div>
        <!-- <div class="row">
          <div class="col-sm-12 col-md-6">
            <message-flow-widget :criteria="currentCriteria"></message-flow-widget>
            <rating-wedget
              v-if="selectedDate"
              :selectedDate="selectedDate"
              :channelFilter="channelFilter">
            </rating-wedget>
          </div>
          <div class="col-sm-12 col-md-6">
            <div id='loading' :class="{'d-none': loadingState}">
              <div style='position: absolute; z-index: 10;'>
                <img src='../assets/images/ui_loading.png'>
              </div>
            </div>
            <rulebase-match-widget :criteria="currentCriteria"></rulebase-match-widget>
          </div>
        </div> -->
        </div>
        <div class="gen-ai-usage-content" v-else-if="selectedTab === 'genAIUsage'">
          <gen-ai-usage-dashboard :criteria="currentCriteria"/>
        </div>
          <!-- Customer Satisfaction -->
        <div class="home-content" v-else>
          <customer-satisfaction-dashboard :criteria="currentCriteria"/>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { DateTime } from 'luxon';

import IncomingMessageWidget from '../components/DashboardWidgets/IncomingMessageWidget.vue';
import ActiveUserWidget from '../components/DashboardWidgets/ActiveUserWidget.vue';
// import MessageByFlowWidget from '../components/DashboardWidgets/MessageByFlowWidget.vue';
// import RuleBaseMatchWidget from '../components/DashboardWidgets/RuleBaseMatchWidget.vue';
import BotPerformanceWidget from '../components/DashboardWidgets/BotPerformanceWidget.vue';
// import RatingWidget from '../components/DashboardWidgets/RatingWidget.vue';
import TrendingTopicsWidget from '../components/DashboardWidgets/TrendingTopicsWidget.vue';
import CustomerSatisfactionDashboard from '../components/DashboardLayout/CustomerSatisfactionDashboard.vue';
import GenAIUsageDashboard from '../components/DashboardLayout/GenAIUsageDashboard.vue';
import dashboardConfig from '../dashboard-config';

export default {
  name: 'home',
  components: {
    'incoming-message-widget': IncomingMessageWidget,
    'active-user-widget': ActiveUserWidget,
    // 'message-flow-widget': MessageByFlowWidget,
    // 'rulebase-match-widget': RuleBaseMatchWidget,
    'bot-performance-widget': BotPerformanceWidget,
    // 'rating-wedget': RatingWidget,
    'trending-topics-widget': TrendingTopicsWidget,
    'customer-satisfaction-dashboard': CustomerSatisfactionDashboard,
    'gen-ai-usage-dashboard': GenAIUsageDashboard,
  },
  data() {
    return {
      loadingState: false,
      maxDate: null,
      currentDate: DateTime.now(),
      originStartDate: null,
      originEndDate: null,
      isSelectedStartDate: false,
      isSelectedEndDate: false,
      selectedStartDate: null,
      selectedEndDate: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      channelFilter: 'all',
      isSelectBotDashboard: true,
      selectedTab: 'botUsageAndPerformance',
      menuConfig: dashboardConfig.getDefaultClientConfig(),
      isOpenChannelDropdown: false,
      dateRangesSelector: {},
    };
  },
  async created() {
    this.menuConfig = await dashboardConfig.getConfig();
    this.originStartDate = this.currentDate.minus({ days: 30 }).startOf('day').setZone('Asia/Bangkok');
    this.originEndDate = this.currentDate.endOf('day').setZone('Asia/Bangkok');
    // we do this to prevent ui bug
    this.maxDate = this.originEndDate.plus({ months: 1 }).toISO();

    this.selectedStartDate = this.originStartDate.toISO();
    this.selectedEndDate = this.originEndDate.toISO();

    this.dateRange.startDate = this.originStartDate.toJSDate();
    this.dateRange.endDate = this.originEndDate.toJSDate();
    this.dateRangesSelectorFormat();
  },
  async mounted() {
    // await this.getSatisfactionSummary();
    this.loadAvailableChannel();
    this.loadingState = true;
  },
  methods: {
    ...mapActions({
      loadAvailableChannel: 'log/loadAvailableChannel',
      getSatisfactionSummary: 'satisfaction/getSatisfactionSummary',
    }),
    async onCalendarToggle(isCalendarOpen) {
      if (isCalendarOpen === false) {
        if (this.isSelectedStartDate && this.isSelectedEndDate) {
          await this.customDates();
        } else {
          this.isSelectedStartDate = false;
          this.isSelectedEndDate = false;
          this.selectedStartDate = this.originStartDate.toISO();
          this.selectedEndDate = this.originEndDate.toISO();
        }
      }
    },
    dateFormat (classes, date) {
      const dateTime = DateTime.fromJSDate(date);

      const newClasses = classes;
      if (!newClasses.disabled) {
        if (this.isSelectedStartDate && this.selectedStartDate) {
          newClasses.disabled = dateTime.toMillis() < DateTime.fromISO(this.selectedStartDate).toMillis() || dateTime.toMillis() > this.currentDate.toMillis();
        } else {
          newClasses.disabled = dateTime.toMillis() > this.currentDate.toMillis();
        }
      }
      return newClasses;
    },
    setStartDateSelection(date) {
      if (date) {
        this.isSelectedStartDate = true;
        this.selectedStartDate = date;
      }
    },
    setEndDateSelection(date) {
      if (date) {
        this.isSelectedEndDate = true;
        this.selectedEndDate = date;
      }
    },
    async customDates() {
      if (this.isSelectedStartDate && this.isSelectedEndDate) {
        if (this.selectedEndDate < this.selectedStartDate) {
          this.dateRange.startDate = this.selectedEndDate;
          this.dateRange.endDate = this.selectedStartDate;
        } else {
          this.dateRange.startDate = this.selectedStartDate;
          this.dateRange.endDate = this.selectedEndDate;
        }
      }

      this.isSelectedStartDate = false;
      this.isSelectedEndDate = false;
      this.selectedStartDate = this.originStartDate.toISO();
      this.selectedEndDate = this.originEndDate.toISO();
    },
    formatDate(str) {
      return DateTime.fromJSDate(str).toFormat('LLL dd, yyyy');
    },
    toggleChannelFilter(value) {
      this.channelFilter = value;
      this.isOpenChannelDropdown = false;
    },
    onClickTabNavigation(selectedTab) {
      this.selectedTab = selectedTab;
    },
    isTrendValueInvalid(trend) {
      return typeof trend === 'string' && trend.toLowerCase() === 'infinity';
    },
    onClickChannelContent() {
      this.isOpenChannelDropdown = !this.isOpenChannelDropdown;
    },
    dateRangesSelectorFormat() {
      const startOfToday = this.currentDate.startOf('day').setZone('Asia/Bangkok');
      const endOfToday = startOfToday.endOf('day');

      const startOfYesterday = startOfToday.minus({ days: 1 });
      const endOfYesterday = startOfYesterday.endOf('day');

      const startOfLast7Days = startOfToday.minus(
        { days: 6 }
      );

      const startOfLast30Days = startOfToday.minus(
        { days: 29 }
      );

      const startOfThisMonth = startOfToday.startOf('month');

      const startOfLastMonth = startOfToday.minus({ months: 1 }).startOf('month');
      const endOfLastMonth = startOfLastMonth.endOf('month');

      this.dateRangesSelector = {
        Today: [startOfToday.toJSDate(), endOfToday.toJSDate()],
        Yesterday: [startOfYesterday.toJSDate(), endOfYesterday.toJSDate()],
        'Last 7 days': [startOfLast7Days.toJSDate(), endOfToday.toJSDate()],
        'This Month': [startOfThisMonth.toJSDate(), endOfToday.toJSDate()],
        'Last Month': [startOfLastMonth.toJSDate(), endOfLastMonth.toJSDate()],
        'Last 30 days': [startOfLast30Days.toJSDate(), endOfToday.toJSDate()],
      };
    }
  },
  computed: {
    ...mapGetters({
      channelList: 'log/channelList',
      satisfactionSummaryData: 'satisfaction/satisfactionSummaryData',
      incomingMessageStat: 'dashboard/incomingMessageStat',
      userEngagemnetStat: 'dashboard/activeUserStat',
      botPerformanceData: 'dashboard/botPerformanceData',
    }),
    currentCriteria() {
      const sinceDate = DateTime.fromJSDate(this.dateRange.startDate).startOf('day').toUTC();
      const untilDate = DateTime.fromJSDate(this.dateRange.endDate).endOf('day').toUTC();
      let granularity;
      const diff = untilDate.startOf('day').diff(sinceDate, 'days').toObject();
      if (diff.days <= 1) granularity = 'hour';
      else if (diff.days <= 31) granularity = 'day';
      else granularity = 'month';

      if (sinceDate) {
        if (this.channelFilter !== 'all') {
          return {
            time: {
              sinceDate,
              untilDate,
              granularity,
            },
            channel: this.channelFilter,
          };
        }
        // channel = all
        return {
          time: {
            sinceDate,
            untilDate,
            granularity,
          },
        };
      }
      return {};
    },
    channelListData() {
      const result = ['all'];
      if (this.channelList && this.channelList.length > 0) {
        for (const ch of this.channelList) {
          result.push(ch);
        }
      }
      return result;
    },
    selectedDate () {
      if (this.currentCriteria && this.currentCriteria.time) {
        return {
          from: this.currentCriteria.time.sinceDate,
          to: this.currentCriteria.time.untilDate,
        };
      }
      return null;
    },
    isValidDateRange() {
      return this.currentCriteria.time.sinceDate && this.currentCriteria.time.untilDate
      && DateTime.fromJSDate(new Date(this.currentCriteria.time.sinceDate)).isValid
      && DateTime.fromJSDate(new Date(this.currentCriteria.time.untilDate)).isValid;
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #F5F6FA;
  .page-header {
    background-color: #FFFFFF;
    padding: 20px 24px 20px 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head-title {
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      text-align: left;
      color: #111B49;
      margin-bottom: 0px;
      .icon {
        margin-right: 0.5rem;
        display: inline-block;
        svg {
          vertical-align: 0;
          height: 1rem;
        }
      }
    }

    .capitalize {
      text-transform: capitalize;
    }
  }
  .home-wrapper {
    .section-title{
      font-size: 16px;
      font-weight: 500;
      line-height: 19.2px;
      text-align: left;
      color: #000000;
      margin-bottom: 24px;
    }
    .home-content{
      padding: 30px 40px;
      .dashboard-row{
        margin-bottom: 24px;
        .dashboard-card-wrapper{
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 24px;
          min-height: 140px;
          .dashboard-card{

            background-color: #FFFFFF;
            border-radius: 16px;
            padding: 16px 18.5px 20px 20px;
            font-weight: 500;
            .card-headline{
              display: flex;
              align-items: center;
              font-size: 14px;
              line-height: 21px;
              text-align: left;
              color : #646A8C;
              padding-bottom: 12px;
              p {
                margin-bottom: 0px;
              }
            }
            .card-headline.with-tooltip{
              justify-content: start;
            }
            .card-headline.with-icon{
              justify-content: space-between;
            }
            .card-detail{
              p {
                margin-bottom: 0px;
              }
              .card-main-detail{
                display: flex;
                align-items: center;
                font-size: 26px;
                line-height: 31.2px;
                color: #0D173C;
                padding-bottom: 4px;
                .text-unit{
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 21px;
                }
                .stat-badge {
                padding: 0px 5px;
                border-radius: 64px;
                font-size: 12px;
                margin-left: 8px;
                height: 18px;
                padding: 4px 6.5px;
                cursor: pointer;
                i {
                  font-size: 8px;
                }
              }
              .stat-badge.decrease {
                color: #EF6767;
                background-color: #FEEFEF;
                i{
                  transform: rotate(180deg);
                }
              }
              .stat-badge.increase {
                color: #44B578;
                background-color: #EDFBF3;
              }
              }
              .card-sub-detail{
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #878A99;
              }
              .no-chagnge-text{
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #878A99;
                padding-left: 8px;
              }
            }
          }
          .dashboard-card-icon-left{
            display: flex;
            align-items: center;
            flex-grow: 1;
            img {
              margin-right: 12px;
              width: 48px;
              height: 48px;
            }
          }
          .dashboard-card:not(.dashboard-card-icon-left){
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .dashboard-card.no-sub-detail{
            display: flex;
            justify-content: flex-start;
          }
        }
      }
      .active-user-content{
        margin-top: 24px;
      }
      .message-fallback-chart{
        display: grid;
        grid-template-columns: repeat(9, minmax(0, 1fr));
        gap: 24px;
        .message-fallback-card-widget{
          background-color: #FFFFFF;
          border-radius: 16px;
        .header-user-widget{
          padding: 16px 16px 12px 16px;
          border-bottom: 1px solid #E9EBEC;
          font-size: 16px;
          font-weight: 500;
          line-height: 19.2px;
          color: #111B49;
          display: flex;
          justify-content: space-between;
          p {
              margin-bottom: 0px
          }
        }
      }
        .message-fallback-card-widget.daily-incoming-message{
          grid-column: span 6 / span 6;
        }
        .message-fallback-card-widget.fallback{
          grid-column: span 3 / span 3;
        }
      }
  }
    .stat-card {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      min-height: 125px;
      .card-header {
        font-size: 0.75rem;
        padding-bottom: 0;
      }
      .card-body {
        padding-bottom: 1rem;
        .stat-value {
          font-size: 1.5rem;
          line-height: 4rem;
        }
        .icon-right {
          flex: 0 0 auto;
          text-align: right;
          line-height: 4rem;
          .icon {
            font-size: 3rem;
            margin-right: 10px;
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
    .widget-card {
      .card-header {
        font-size: 1rem;
      }
    }
    .filter-wrapper{
      display: flex;
      .export-button {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 24px;
        background-color:  #3371ff;
        border: 0px;
        gap: 4px;
        color: #fff;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.32px;
        white-space: nowrap;
        padding: 8px 16px ;
        height: 40px;
        > i {
          color: #fff;
        }
        i.bx {
          color: #fff;
        }
        &:not(:disabled):hover {
          box-shadow: 0px 2px 24px 0px rgba(51, 113, 255, 0.2);
          background-color: #2962df;
        }
        &:not(:disabled):active {
          background-color:  #3371ff;
        }
        &:disabled {
          opacity: 0.65;
          background-color:  #3371ff;
        }
      }
      .channel-dropdown-content{
        p{
            margin-bottom: 0px;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: #111B49;
          }
        .channel-selected{
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          padding: 8px 12px;
          border: 1px solid #DADCE4;
          border-radius: 8px;
          min-width: 130px;
          height: 40px;
          i{
            color: #868BA6;
          }
        }
        .channel-dropdown{
          background-color: #FFFFFF;
          border-radius: 8px;
          border: 1px solid #DADCE4;
          position: absolute;
          margin-top: 4px;
          padding: 8px 12px;
          min-width: 130px;
          .channel-item{
            padding: 8px 0px;
          }
          .channel-item.selected-channel{
            padding: 8px 0px;
            color: #2962DF;
          }
        }
      }
      .date-picker-content{
        padding: 0px 8px;
        display: flex;
        align-items: center;
        .date-picker-input{
          i{
            padding-right: 4px;
            color: #3371ff;
          }
        }
      }
    }
    .dashboard-tab-navigation{
      display:flex;
      padding: 30px 40px 0px 40px;
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      color: #868BA6;
      p{
        margin-bottom: 8px;
        // margin-right: 8px;
        padding-right: 24px;
        padding-left: 24px;
      }
      .tab-item{
        border-bottom: 2px solid #E7E8EE;
        cursor: pointer;
      }
      .tab-item.selected-tab{
        color: #2962DF;
        border-color: #2962DF;
      }
    }
  }
}
#loading{
    position: absolute;
    width: 97%;
    height: 95%;
    display: flex;
    justify-content: center;
    background: darkgrey;
    align-items: center;
    z-index: 2;
    opacity: 0.2;
}
.disabled{
  pointer-events:none;
}
</style>
